import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesUp } from '@fortawesome/free-solid-svg-icons';
import DashboardUtterance from './components/DashboardUtterance'
import ChatCloseButton from "./components/ChatCloseButton";
import api from '../api/api'; 
import { v4 as uuidv4 } from 'uuid';
import Header from "./Header";
import { useDashboardContext } from '../../context/DashboardContext';
import { isAuthenticated } from "../api/api";


export default function DashboardChatArea({ chatScreenChatId, selectedSecCode, companyName, clickCloseButton, chatAreaWidth, toggleChat, chatDefaultSetting }) {
    const { state: dashboardState } = useDashboardContext(); // Contextから取得
    const [message, setMessage] = useState('');
    const [showUtteranceArea, setShowUtteranceArea] = useState(false);
    const [userMessage, setUserMessage] = useState(''); // DashboardUtterance に渡すメッセージ
    // const [showSpinner, setShowSpinner] = useState(false);
    const [response, setResponse] = useState('');
    const [showAgent, setShowAgent] = useState([]);
    const [graphs, setGraphs] = useState([]);
    const [showNavigation, setShowNavigation] = useState(true);
    const ws = useRef(null);
    const [chatId, setChatId] = useState(chatScreenChatId ? chatScreenChatId : uuidv4());

    // チャットエリアの追加
    const addChatArea = (message) => {
        setUserMessage(message); // DashboardUtterance に表示するメッセージをセット
        setShowUtteranceArea(true);
    };

    const handleSendMessage = (e) => {
        e.preventDefault();
        // メッセージ送信処理
        if (message.trim()) {
            addChatArea(message);
            setMessage(''); // メッセージ送信後に入力をクリア
        }
        sendMessage(chatId, message.trim(), true, false);
    };

    // Web socketの接続
      useEffect(() => {
          // WebSocketの接続を確立
          const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
          ws.current = new WebSocket(`${protocol}://${process.env.REACT_APP_WS_URL}/ws/chat/${chatId}/`);
    
          // WebSocketメッセージ受信時の処理
          ws.current.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.operation_type === 'utterance') {
              setResponse(data.operation);  // 受信したメッセージを更新
            } else if (data.operation_type === 'dashboard') {
              setResponse(data.operation);  // 受信したメッセージを更新
            } else if (data.operation_type === 'agent_operation') {
              if (data.operation === "add_agent") {
                setShowAgent(prevAgents => [...prevAgents, data.agent_name]);
              } else if (data.operation === 'remove_agent') {
                setShowAgent(prevAgents => [...prevAgents.slice(0, -1)]);
              }
            } else if (data.operation_type === "graph_utterance") {
              const graphData = Object.entries(data.fig_data).map(([key, fig]) => ({ fig }));
              setGraphs(prevGraphs => [...prevGraphs, ...graphData]);
            } else {
            }
          };
      
          // WebSocket接続終了時の処理
          return () => {
            if (ws.current) {
              ws.current.close();
            }
          };
      }, [chatId]);

    const sendMessage = async (chatId, prompt, is_dashboard, is_main_chat) => {
        setShowNavigation(false);
        // setShowSpinner(true);
        setGraphs([]);
        
        try {
          const data = {
            task: 'action',
            prompt: prompt,
            is_dashboard: is_dashboard,
            is_main_chat: is_main_chat,
            sec_code: selectedSecCode,
            company_name: companyName,
          }
            await api.post(`${process.env.REACT_APP_API_URL}/chat/api/send-chat/${chatId}/`, data);
        } catch (error) {
            console.error('Error saving note:', error);
        }
        // setShowSpinner(false);
      }
    
    
    const handleKeyDown = (e) => {
        if (e.isComposing || e.keyCode === 229) {
          // IME入力中の場合はEnterキーを無視（変換確定のため）
          return;
        }

        if (e.key === 'Enter' && e.shiftKey) {
          e.preventDefault();
          setMessage(prevMessage => prevMessage + '\n');
        } else if (e.key === 'Enter') { // Enter で送信
          e.preventDefault();
          handleSendMessage(e);
        }
    };

    return (
        <div className="dashboard-chat-area" style={{ width: chatAreaWidth + 'px'}}>
          <div className="dashboard-chat-area-header md:mt-[0px] mt-[20px]">
            <Header secCode={dashboardState.secCode} displayDailyReportSettings={false} addCompany={null} removeCompany={null} displayWhatIsDailyReport={null} toggleChat={toggleChat} chatDefaultSetting={chatDefaultSetting} />
          </div>
                        
            {showUtteranceArea ? <DashboardUtterance userMessage={userMessage} response={response} agents={showAgent} graphData={graphs} /> : null} {/* userMessage を渡す */}
            <div className="dashboard-query-area">
                {showNavigation ? <div className="instruction">
                    <p className="example">流動比率ってなに？</p>
                    <p className="example">x社の3年間のPERの推移を教えて。</p>
                </div>
                : null
                }
                <form className="dashboard-message-form" method="POST" onSubmit={handleSendMessage}>
                  <div className="chat-dashboard-messages">
                      <textarea
                          id="dashboard-message"
                          className={`chat-dashboard-input ${isAuthenticated() ? "" : "bg-gray-300"}`}
                          placeholder={isAuthenticated() ? "具体的なほどうまく答えられます" : "チャットをするにはログインが必要です"}
                          value={isAuthenticated() ? message : ""}
                          onChange={(e) => setMessage(e.target.value)}
                          onKeyDown={handleKeyDown}
                          disabled={!isAuthenticated()} // 未ログインなら入力不可
                      ></textarea>
                      <button
                          className={`chat-dashboard-message-button ${isAuthenticated() ? "bg-gray-700" : "bg-gray-400"}`}
                          type="submit"
                          disabled={!isAuthenticated()} // 未ログインならボタン無効
                      >
                          <FontAwesomeIcon icon={faAnglesUp} />
                      </button>
                  </div>
              </form>
            </div>
        </div>
    );
}
